import { ThemeOptions } from "@mui/material";
import { HypeIcon } from "@ob/core";

export const muiAlert: ThemeOptions["components"] = {
  MuiAlert: {
    variants: [
      {
        props: { variant: "global", severity: "error" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.alertWidget.error.backgroundColor,
          color: theme.palette.alertWidget.error.color,
        }),
      },
      {
        props: { variant: "global", severity: "warning" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.alertWidget.warning.backgroundColor,
          color: theme.palette.alertWidget.warning.color,
        }),
      },
      {
        props: { variant: "global", severity: "info" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.alertWidget.info.backgroundColor,
          color: theme.palette.alertWidget.info.color,
        }),
      },
      {
        props: { variant: "global", severity: "success" },
        style: ({ theme }) => ({
          backgroundColor: theme.palette.alertWidget.success.backgroundColor,
          color: theme.palette.alertWidget.success.color,
        }),
      },
    ],
    defaultProps: {
      iconMapping: {
        success: <HypeIcon name="icon_check-o" size={20} color="success.dark" />,
        error: <HypeIcon name="icon_check_alert" size={20} color="error.light" />,
        info: <HypeIcon name="icon_check_alert" size={20} color="info.dark" />,
        warning: <HypeIcon name="icon_check_alert" size={20} color="warning.dark" />,
      },
      slots: {
        closeIcon: () => <HypeIcon name="icon_cancel" color="inherit" />,
      },
    },
    styleOverrides: {
      root: ({ ownerState: { severity, variant }, theme }) => {
        const defaultStyle = {
          color: theme.palette.common.white,
          borderRadius: "16px",
          width: "100%",
        };
        if (!severity || !variant) {
          return defaultStyle;
        }
        switch (variant) {
          case "outlined":
          case "standard":
            return {
              color: theme.palette[`${severity}`].dark,
              borderRadius: "16px",
              width: "100%",
            };
          case "widget":
            return {
              backgroundColor:
                theme.palette.alertWidget[`${severity}`].backgroundColor,
              color: theme.palette.alertWidget[`${severity}`].color,
              borderRadius: "16px",
            };
          default:
            return defaultStyle;
        }
      },
    },
  },
};
